import React, { Component } from "react";
import { connect } from "react-redux";
import Layout from "../Layout";
import MainSideBar from "./MainSideBar";
import "./index.scss";
import { sideBar } from "../Actions/SideBar";
import "react-toastify/dist/ReactToastify.css";
import withTranslationWrapper from "../HOC/HocTranslate";

/**
 * App shell: left sidebar menus + layout header.
 * Menu search (all sidebar modules / nested rest menus) is available in Header via MenuSearch.
 */
class Wrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      open: this.props.sideBar || true,
    };
  }

  handleDrawer = () => {
    this.setState(
      {
        open: !this.state.open,
      },
      () => {
        this.props.dispatch(sideBar(this.state.open));
      },
    );
  };
  render() {
    return (
      <>
        <MainSideBar
          {...this.props}
          userInfo={this.props.logInUser}
          sidebarToggle={this.state.open}
        />
        <Layout
          {...this.props}
          {...this.state}
          small
          sidebarToggle={this.state.open}
          handleDrawer={this.handleDrawer}
        />
      </>
    );
  }
}
const mapState = (state) => ({
  logInUser: state.logInUsers,
  deviceLimit: state.deviceLimit,
  sideBar: state.sideBar,
});

const mapStateToProps = connect(mapState);

export default withTranslationWrapper(mapStateToProps(Wrapper));
